import React, { lazy, Suspense } from 'react'
import { useStore } from 'zustand'

import { bookingFollowUpStore, dismissBookingFollowUp } from './store'

// The dialog drags the route picker (the route table kit) in; the app root
// that mounts this host must stay light, so the chunk fetches on the first
// booking, never at boot.
const BookingFollowUpDialog = lazy(() => import('./BookingFollowUpDialog'))

/**
 * Renders the booking follow-up dialog (PRODUCT-525) for every opening the
 * module's store holds. Mounted ONCE, at the app root beside
 * `AsyncModalPortal` — inside the Apollo, router and antd providers the
 * dialog reads, and above every route, so it outlives the "Rent container"
 * modal that hosted the form and the navigation to the Rentals tab.
 *
 * The lazy component lives HERE, in module scope, never in a store: React
 * initialises a lazy component by writing to it, and a store that freezes
 * what it holds (immer) turned that write into the production crash of
 * PRODUCT-545. The store hands this host ticket ids; this host hands them
 * to the dialog.
 */
export const BookingFollowUpHost = () => {
  const entries = useStore(bookingFollowUpStore, (state) => state.entries)
  if (!entries.length) return null
  return (
    <Suspense fallback={null}>
      {entries.map(({ key, ticketIds }) => (
        <BookingFollowUpDialog
          key={key}
          ticketIds={ticketIds}
          onClose={() => dismissBookingFollowUp(key)}
        />
      ))}
    </Suspense>
  )
}

export default BookingFollowUpHost
